import script from "./inlineTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./inlineTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./inlineTextEditor.vue?vue&type=style&index=0&id=3b670a19&lang=css"

const __exports__ = script;

export default __exports__